var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83761 14.8588C12.6247 14.8588 15.6948 11.7888 15.6948 8.00167C15.6948 4.21458 12.6247 1.14453 8.83761 1.14453C5.05052 1.14453 1.98047 4.21458 1.98047 8.00167C1.98047 11.7888 5.05052 14.8588 8.83761 14.8588ZM4.25512 11.7859C3.40536 10.758 2.89475 9.43948 2.89475 8.00167C2.89475 4.71952 5.55546 2.05882 8.83761 2.05882C10.2754 2.05882 11.594 2.56942 12.6218 3.41919L4.25515 11.7859C4.25514 11.7859 4.25513 11.7859 4.25512 11.7859ZM4.88976 12.4438C5.93946 13.3774 7.32231 13.9445 8.83761 13.9445C12.1198 13.9445 14.7805 11.2838 14.7805 8.00167C14.7805 6.48648 14.2134 5.10372 13.28 4.05404L4.90165 12.4324C4.89774 12.4363 4.89377 12.4401 4.88976 12.4438Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.e223a1c67d8a19f8eb774b093e2bb257.svg";
export { ForwardRef as ReactComponent };